var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuruLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-153 -46 652 652",
    style: {
      enableBackground: "new -153 -46 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408,277.4l-32.5-122.6C351.3,63.4,260.4,9.7,172.3,34.9L54.5,68.7C-33.2,93.8-84.9,188.4-60.6,279.9l32.4,122.6 C-4,493.9,86.9,547.7,175,522.4l117.8-33.9C380.5,463.5,432.2,368.9,408,277.4z M217,404.3c-14.1,5.4-29,8.2-44.1,8.2 c-10.1,0-20.1-1.3-29.8-4c-72.3-21.4-113.5-97.3-92.2-169.5c6.1-20.8,17.1-39.8,32-55.4c23.4-24.5,55.7-38.5,89.5-38.7 c60.4,0.7,96.8,46.6,98.5,48.4c4.2,5.4,3.4,13.2-1.7,17.8c-5,4.2-12.5,3.6-16.7-1.4c-0.1-0.2-0.3-0.3-0.4-0.5 c-0.3-0.4-31.2-38.7-79.9-39.2h-1c-27,0.6-52.6,12-71.2,31.6C80,222.2,69,250,69.6,278.8c0.5,48.8,32.9,91.6,79.8,105.2 c19.6,5.1,40.4,3.9,59.3-3.5c24.2-9.1,46.9-29.9,54.1-53.6c9.2-5.2,18.1-11,26.6-17.4C290.7,352.9,254.3,390.1,217,404.3z  M318.1,266.2c-9.4,10.2-19.8,19.5-31,27.7c-7,5.2-14.3,9.9-22,14c-15.6,8.9-33.1,13.6-51.1,13.8c-32.4-0.7-44.2-19.4-44.5-36.5 c-0.3-9,2.9-17.7,9-24.3c7.8-8.2,19.4-12.4,34.8-12.4c22.5,0.3,44.1,8.9,60.7,24.2c9.4-7.1,18.2-14.9,26.3-23.6 c4.3-4.9,11.7-5.4,16.6-1.2c0.2,0.2,0.4,0.3,0.5,0.5C322.3,253.3,322.6,261.1,318.1,266.2z M195.8,278.5c-1.6,1.8-2.4,4.2-2.2,6.6 c0,9.2,11.4,11.4,20.8,11.6c13.2-0.1,26.1-3.6,37.6-10c-11.4-8-24.8-12.5-38.7-12.9C202.1,273.7,197.6,276.7,195.8,278.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuruLogo);
export default __webpack_public_path__ + "static/media/guru-logo.3c1f71790942141ba7501d924260e075.svg";
export { ForwardRef as ReactComponent };